import { inject } from '@angular/core';
import { type CanActivateFn, Router } from '@angular/router';

import { environment } from '../../environments/environment';
import { UserService } from '../shared/services/user.service';
import { UserRole } from '#backend/common/user-types';
import { urls } from '../shared/constants';

/**
 * Guard que verifica se o usuário pode fazer solicitações (não é visualizador)
 */
export const canRequestGuard: CanActivateFn = async (route, state) => {
  // Skip guard if debug flag is enabled
  if (environment.skipAuth) {
    return true;
  }

  const userService = inject(UserService);
  const router = inject(Router);

  try {
    const user = await userService.requireUser();

    // Visualizadores não podem fazer solicitações
    if (user.role === UserRole.VISUALIZADOR_CLIENTE) {
      // Redirecionar para dashboard (role-based access should hide menu)
      router.navigate([urls.customerFacingDashboard], { replaceUrl: true });
      return false;
    }

    return true;
  } catch (error) {
    console.error('[CanRequestGuard] Falha ao carregar usuário', error);
    router.navigate([urls.login]);
    return false;
  }
};
